import React from "react";

import cx from "@hsl/core/utils/cx";

import { type TabConfig } from "../../../config/types";
import { Translate } from "../../../hooks/useTranslation";
import { Footnote, Preface } from "../../Table";
import Tabs, { type TabsProps } from "../../Tabs";

interface Props {
    tabs?: (TabConfig & { date?: string })[];
    content: TabsProps["content"] | React.ReactNode;
    config: TabConfig;
    spacedTabs?: boolean;
    footnote?: string;
    onChange?(label: string): void;
}

const View = ({
    tabs,
    content,
    config,
    spacedTabs,
    footnote,
    onChange,
}: Props) => {
    if (Array.isArray(tabs) && tabs.length > 0) {
        return (
            <>
                <Preface className="mb-2 mt-4">{config.preface}</Preface>
                <Tabs
                    withBorder
                    tabs={tabs.map((tab) => ({
                        ...tab,
                        label: tab.date ? (
                            <>
                                <Translate>{tab.label}</Translate> ({tab.date})
                            </>
                        ) : (
                            <Translate>{tab.label}</Translate>
                        ),
                    }))}
                    content={content as TabsProps["content"]}
                    containerClassName="mt-2 mb-4"
                    tabClassName={cx({ "mr-12": spacedTabs })}
                    onChange={(i) =>
                        onChange && onChange(tabs[i]?.label ?? `tab-${i}`)
                    }
                />
                <Footnote>{footnote}</Footnote>
            </>
        );
    }
    return <>{content}</>;
};

export default View;
